import styled, { css } from 'styled-components'

import Div from 'ui/elements/Div'

const COLUMNS_COUNT = 12

const BREAKPOINTS = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px'
}

const CONTAINER_MAX_WIDTHS = {
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1140px'
}

const createMediaQuery = (breakpoint, { container = false, breakpoints = BREAKPOINTS }) => {
  const mergedBreakpoints = { ...BREAKPOINTS, ...breakpoints }

  if (!mergedBreakpoints[breakpoint]) return ''

  if (container) {
    return `@container (min-width: ${mergedBreakpoints[breakpoint]})`
  }

  return `@media (min-width: ${mergedBreakpoints[breakpoint]})`
}

const generateColSpanStyles = (props) => {
  const styles = Object.entries(props).map(([breakpoint, span]) => {
    if (!span) return ''

    if (breakpoint === 'xs') {
      return `
        grid-column: span ${span};
      `
    }

    return `
      ${createMediaQuery(breakpoint, props)} {
        grid-column: span ${span};
      }
    `
  })

  return styles.join('')
}

const generateMediaQueryStyles = (props) => {
  if (props.fluid) return ''

  const styles = Object.entries(CONTAINER_MAX_WIDTHS).map(
    ([breakpoint, width]) => `
      ${createMediaQuery(breakpoint)} {
        max-width: ${width};
      }
    `
  )

  return styles.join('')
}

export const Container = styled(Div)`
  width: 100%;

  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;

  ${(props) => css`${generateMediaQueryStyles(props)}`}
`

export const Row = styled(Div)`
  display: grid;
  grid-template-columns: repeat(${COLUMNS_COUNT}, 1fr);
  gap: 15px;

  ${({ gap }) => gap && css`
    gap: ${gap}px;
  `}

  ${({ noGutter }) => noGutter && css`
    gap: 0;
  `}

  ${({ container }) => container && css`
    container-type: inline-size;
  `}
`

export const Col = styled(Div)`
  grid-column: 1 / -1; // Default full width on mobile

  ${(props) => css`${generateColSpanStyles(props)}`}
`
